import palette from './palette';

export default {
  fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
  h1: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '28px',
    letterSpacing: '-0.24px',
    lineHeight: 1.214
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '24px',
    letterSpacing: '-0.24px',
    lineHeight: 1.25
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: 1.3
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '17px',
    letterSpacing: '-0.06px',
    lineHeight: 1.412
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '15px',
    letterSpacing: '-0.05px',
    lineHeight: 1.333
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: 1.429
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '15px',
    letterSpacing: '-0.05px',
    lineHeight: 1.467
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '13px',
    letterSpacing: '-0.05px',
    lineHeight: 1.538
  },
  body1: {
    color: palette.text.primary,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: 1.429
  },
  body2: {
    color: palette.text.secondary,
    fontSize: '13px',
    letterSpacing: '-0.04px',
    lineHeight: 1.385
  },
  button: {
    color: palette.text.primary,
    fontSize: '14px'
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '12px',
    letterSpacing: '0.2px',
    lineHeight: 1.333
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: 1.182,
    textTransform: 'uppercase'
  }
};
